import React from 'react'
import { Link } from 'react-router-dom'
import { FormattedDate } from 'react-intl'
import { Container } from './components/Container'

interface Props {
  action?: string
  image?: string
  title?: string
  link: string
  subtitle?: string
  tags?: Array<{}>
  date?: string
}

export const PostTile: React.FC<Props> = ({
  title,
  action = 'Read More',
  link,
  image,
  subtitle,
  tags,
  date
}) => {
  return (
    <Container>
      <div className='item'>
        <Link to={link}>
          <div
            className='image'
            style={{
              backgroundImage: `url(${image})`
            }}
          />
          <div className='content'>
            {tags && tags?.length > 0 && (
              <ul className='tags'>
                {tags?.map((tag: any) => {
                  return (
                    <li key={tag.url_key}><Link to={`/blog/tag/${tag.url_key}`}>{tag.name}</Link></li>
                  )
                })}
              </ul>
            )}
            <div className='title'>
              {title}
            </div>
            <div className='subtitle'>
              {subtitle}
            </div>
            <div className='date'>
              <FormattedDate
                value={date}
                year='numeric'
                month='long'
                day='2-digit'
              />
            </div>
          </div>
          <div className='action'>
            <span>
              {`${action} >`}
            </span>
          </div>
        </Link>
      </div>
    </Container>
  )
}
